const filtersReducerDefaultState = {
  text: "",
  groups: []
};

export default (state = filtersReducerDefaultState, action) => {
  switch (action.type) {
    case "SET_TEXT_FILTER":
      return {
        ...state,
        text: action.text
      };
    case "SET_GROUP_FILTER":
      return {
        ...state,
        groups: action.group
      };
    default:
      return state;
  }
};
